import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { Dialog, Divider, Box } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import './DeleteDialog.scss';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function DeleteDialog(props) {
    const { open, handleClose, dispatchAction, name } = props;

    return (
        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            maxWidth='sm'
            fullWidth='true'
        >
            <DialogTitle sx={{ m: 0, p: 2, fontWeight: 'bold', fontSize:'16px' }} id="customized-dialog-title">
                Delete Session?
            </DialogTitle>
            <Typography sx={{ pl: 2, fontSize: '12px', color:'#6F6F6F' }}>
                Please confirm that you understand that this action cannot be undone.
            </Typography>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent className='delete-dialog-content'>
                <Typography className='delete-warning-message'>Are you sure you want to delete "{name}"? This action cannot be undone and will permanently remove the item from your records.</Typography>
                <Divider />
                <Box className='delete-buttons-holder'>
                    <Button className='delete-cancel-button' variant="outlined" size="large" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button className='delete-submit-button' variant="contained" size="large" onClick={dispatchAction}>
                        Delete
                    </Button>
                </Box>
            </DialogContent>
        </BootstrapDialog>
    );
}
